(function () {
  'use strict';
  var host = document.getElementById('hh-dog-gift-root');
  var configNode = document.getElementById('hh-dog-gift-config');
  if (!host || !configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); }
  catch (error) { console.error('HH gift config:', error); return; }

  var eligible = new Set((config.eligibleProductIds || []).map(Number));
  var giftProduct = Number(config.giftProductId);
  var giftVariants = new Set((config.giftVariantIds || []).map(Number));
  var dialog = document.getElementById('hh-dog-gift-dialog');
  var confirmButton = host.querySelector('[data-hh-gift-confirm]');
  var message = document.getElementById('hh-dog-gift-message');
  var radios = Array.from(host.querySelectorAll('input[name="hh-dog-gift-color"]'));
  var cart = null;
  var loading = false;
  var timer = null;
  var shouldReopenDrawer = false;
  var promptedToken = '';
  var promptKey = 'hh-dog-gift-prompted-token';

  try { promptedToken = window.sessionStorage.getItem(promptKey) || ''; }
  catch (e) { promptedToken = ''; }

  function apiUrl(endpoint) {
    var localeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var prefix = localeRoot.replace(/\/?$/, '/');
    return prefix + (endpoint === 'cart.js' ? 'cart.js' : 'cart/' + endpoint);
  }
  async function readCart() {
    var response = await fetch(apiUrl('cart.js'), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Kurven kunne ikke hentes.');
    return response.json();
  }
  async function changeCart(endpoint, payload) {
    var response = await fetch(apiUrl(endpoint), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    var data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Kurven kunne ikke opdateres.');
    return data;
  }
  function qualifyingCount(current) {
    return (current.items || []).reduce(function (n, item) {
      return n + (eligible.has(Number(item.product_id)) ? item.quantity : 0);
    }, 0);
  }
  function giftedItems(current) {
    return (current.items || []).filter(function (item) {
      return Number(item.product_id) === giftProduct &&
        item.properties && String(item.properties._hh_dog_gift) === '1';
    });
  }
  async function normalizeGifts(current, preferredVariantId) {
    var changed = false;
    for (var attempt = 0; attempt < 20; attempt++) {
      var marked = giftedItems(current);
      var keep = qualifyingCount(current) >= 2 &&
        (marked.find(function (item) { return Number(item.variant_id) === Number(preferredVariantId); }) || marked[0]);
      var extra = marked.find(function (item) { return item !== keep; });
      var target = extra || (keep && keep.quantity > 1 ? keep : null);
      if (!target) return { cart: current, changed: changed };
      await changeCart('change.js', { id: target.key, quantity: target === keep ? 1 : 0 });
      current = await readCart();
      changed = true;
    }
    throw new Error('Kurven blev ændret under farvevalget. Prøv igen.');
  }
  function alreadyHasFlexy(current) {
    return (current.items || []).some(function (item) {
      return Number(item.product_id) === giftProduct && giftVariants.has(Number(item.variant_id));
    });
  }
  function rememberPrompt(current) {
    promptedToken = current.token || 'this-session';
    try { window.sessionStorage.setItem(promptKey, promptedToken); } catch (e) {}
  }
  function forgetPrompt() {
    promptedToken = '';
    try { window.sessionStorage.removeItem(promptKey); } catch (e) {}
  }
  function setMessage(text) {
    message.textContent = text || '';
    message.hidden = !text;
  }
  function colorOf(item) {
    return (item.variant_title || '').split(' / ')[0] || 'valgt farve';
  }
  function makeTeaser(container) {
    var node = container.querySelector('.hh-dog-gift-teaser');
    if (!node) {
      node = document.createElement('section');
      node.className = 'hh-dog-gift-teaser';
      node.setAttribute('aria-label', 'Dog Copenhagen-gavekampagne');
      container.prepend(node);
    }
    return node;
  }
  function updateTeasers(current) {
    var count = qualifyingCount(current);
    var gift = giftedItems(current)[0];
    var flexy = (current.items || []).find(function (item) { return Number(item.product_id) === giftProduct; });
    var spots = [
      document.querySelector('cart-drawer .drawer__footer'),
      document.querySelector('#main-cart .cart__footer-wrapper') ||
        document.querySelector('#main-cart .cart__footer')
    ].filter(Boolean);
    spots.forEach(function (spot) {
      var node = makeTeaser(spot);
      node.replaceChildren();
      node.hidden = count === 0;
      if (count === 0) return;
      var title = document.createElement('strong');
      var info = document.createElement('p');
      var action = document.createElement(count === 1 ? 'a' : 'button');
      if (count === 1) {
        title.textContent = 'I er tæt på en gratis gave';
        info.textContent = 'Vælg ét Dog Copenhagen-produkt mere, så kan I få en Flexy-poseholder.';
        action.textContent = 'Se kampagneprodukterne';
        action.href = '/collections/dog-copenhagen-sammensaet-dit-saet';
      } else if (gift || flexy) {
        title.textContent = 'Flexy-poseholderen er i kurven';
        info.textContent = 'Farve: ' + colorOf(gift || flexy);
        action.textContent = gift ? 'Skift farve' : 'Se farver';
        action.type = 'button';
        action.addEventListener('click', function () { openSelector(); });
      } else {
        title.textContent = 'I har en gratis Flexy-gave til gode!';
        info.textContent = 'Vælg den farve, der passer til jeres Dog Copenhagen-sæt.';
        action.textContent = 'Vælg farve';
        action.type = 'button';
        action.addEventListener('click', function () { openSelector(); });
      }
      node.append(title, info, action);
    });
  }
  function openSelector() {
    if (loading || !cart || qualifyingCount(cart) < 2 || dialog.open || !dialog.showModal) return;
    setMessage('');
    var existing = giftedItems(cart)[0];
    radios.forEach(function (r) { r.checked = !!existing && Number(r.value) === Number(existing.variant_id); });
    confirmButton.disabled = !radios.some(function (r) { return r.checked && !r.disabled; });
    var drawer = document.querySelector('cart-drawer');
    shouldReopenDrawer = !!drawer && drawer.classList.contains('active');
    if (shouldReopenDrawer && typeof drawer.close === 'function') drawer.close();
    dialog.showModal();
  }
  async function refreshTheme() {
    if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
      window.location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.isInitialized && typeof drawer.reload === 'function') await drawer.reload();
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hh-dog-gift', cartData: cart });
    }
    window.setTimeout(function () { if (cart) updateTeasers(cart); }, 550);
  }
  async function chooseGift() {
    var selected = radios.find(function (r) { return r.checked && !r.disabled; });
    if (!selected || !cart || loading) return;
    var existing = giftedItems(cart)[0];
    if (existing && Number(existing.variant_id) === Number(selected.value)) { dialog.close(); return; }
    loading = true;
    confirmButton.disabled = true;
    setMessage('');
    try {
      var fresh = await readCart();
      if (qualifyingCount(fresh) < 2) throw new Error('Der skal være mindst 2 kampagneprodukter i kurven.');
      var desiredVariantId = Number(selected.value);
      if (!giftedItems(fresh).some(function (item) { return Number(item.variant_id) === desiredVariantId; })) {
        await changeCart('add.js', { items: [{ id: desiredVariantId, quantity: 1, properties: { _hh_dog_gift: '1' } }] });
        fresh = await readCart();
      }
      var result = await normalizeGifts(fresh, desiredVariantId);
      cart = result.cart;
      if (qualifyingCount(cart) < 2) throw new Error('Der skal være mindst 2 kampagneprodukter i kurven.');
      rememberPrompt(cart);
      dialog.close();
      await refreshTheme();
    } catch (error) {
      setMessage(error.message || 'Kunne ikke vælge denne farve. Prøv igen.');
    } finally {
      loading = false;
      confirmButton.disabled = !radios.some(function (r) { return r.checked && !r.disabled; });
    }
  }
  async function sync() {
    if (loading) return;
    loading = true;
    try {
      var fresh = await readCart();
      var result = await normalizeGifts(fresh);
      fresh = result.cart;
      var count = qualifyingCount(fresh);
      if (count < 2) forgetPrompt();
      cart = fresh;
      if (result.changed) await refreshTheme();
      updateTeasers(fresh);
      if (count >= 2 && !alreadyHasFlexy(fresh) && promptedToken !== (fresh.token || 'this-session')) {
        rememberPrompt(fresh);
        window.setTimeout(function () { if (cart && qualifyingCount(cart) >= 2) openSelector(); }, 430);
      }
    } catch (e) {
      console.warn('HH Dog gift:', e);
    } finally {
      loading = false;
    }
  }
  function scheduleSync() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () { window.hhCartMutation(sync); }, 330);
  }
  host.querySelectorAll('[data-hh-gift-dismiss]').forEach(function (b) {
    b.addEventListener('click', function () { dialog.close(); });
  });
  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      confirmButton.disabled = !radios.some(function (r) { return r.checked && !r.disabled; });
    });
  });
  confirmButton.addEventListener('click', function () { window.hhCartMutation(chooseGift); });
  dialog.addEventListener('close', function () {
    if (!cart) return;
    rememberPrompt(cart);
    if (shouldReopenDrawer) {
      shouldReopenDrawer = false;
      var drawer = document.querySelector('cart-drawer');
      window.setTimeout(function () {
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }, 120);
    }
  });
  ['cart-add', 'cart-update', 'cart-remove', 'cart-drawer-open', 'quick-buy-action-complete'].forEach(function (name) {
    document.addEventListener(name, scheduleSync);
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) scheduleSync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.hhCartMutation(sync); }, { once: true });
  else window.hhCartMutation(sync);
})();
